var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('the-tab-recent-basic-chart',{attrs:{"latestTime":this.chartData[this.chartData.length - 1][0],"loading":_vm.loading,"options":_vm.options},model:{value:(_vm.selectedTimeRange),callback:function ($$v) {_vm.selectedTimeRange=$$v},expression:"selectedTimeRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }